import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/www/hotlot/web/layouts/default.vue").then(m => m.default || m)),
  profile: defineAsyncComponent(() => import("/var/www/hotlot/web/layouts/profile.vue").then(m => m.default || m))
}